// components/layout/clientModules.js
// Uganda client menu switches (server: services/clientModuleService.js). Only "client"
// accounts on the Uganda menu (no country, or UG) are affected — the same rule the
// server uses. Wallet & Payments is never switched.
export const CLIENT_MODULE_BY_PATH = {
  '/exchange': 'buy_usdt',
  '/crypto-withdraw': 'crypto_withdraw',
  '/analytics': 'analytics',
  '/referral': 'referral',
  '/isp': 'isp',
};

export const isUgandaClient = user => !!user && user.role === 'client' && (!user.countryCode || user.countryCode === 'UG');

// Drop switched-off items (modules[key] === false); unknown/not loaded = keep. Empty groups go.
export function filterClientNav(nav, modules) {
  if (!modules) return nav;
  return nav
    .map(g => ({ ...g, items: g.items.filter(i => { const k = CLIENT_MODULE_BY_PATH[i.to]; return !k || modules[k] !== false; }) }))
    .filter(g => g.items.length > 0);
}
